import React from "react";
import "./App.css";
import FlagGame from "./components/FlagGame";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Can you guess the country?</h1>
      </header>
      <main>
        <FlagGame />
      </main>
    </div>
  );
}

export default App;
